import { render } from "./TheHub.vue?vue&type=template&id=1020e545"
import script from "./TheHub.vue?vue&type=script&lang=js"
export * from "./TheHub.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__